'use client';

import { TooltipProvider } from '@videoblocks/design-system';

export function Providers({ children }) {
    return <TooltipProvider>{children}</TooltipProvider>;
}
